import { ReactComponent as SortIcon } from "assets/icons/sortIcon.svg";
import { classNames } from "helpers/ClassNameHelper";
import React from "react";
import { HeaderGroup, SortingRule } from "react-table";
import { TableType } from "./Table";
import { handleKeyDown } from "modules/common/utils/keyboardUtils";

interface Props {
    headerGroups: HeaderGroup<object>[];
    sortBy?: SortingRule<object>;
    tableType: TableType;
    disableSort?: boolean;
}

function getSortIconClass(column: HeaderGroup<object>, sortBy: SortingRule<object> | undefined) {
    if (sortBy && sortBy.id === column.id) {
        return sortBy.desc ? "bottom-active" : "top-active";
    }
    return "";
}

export const TableHeader: React.FC<Props> = ({ headerGroups, sortBy, tableType, disableSort }) => {
    return (
        <thead className="table-head">
            {headerGroups.map(headerGroup => (
                <tr className="table-srow" {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column: any) => {
                        // Determine base classes based on tableType
                        const baseHeaderClass = `${tableType}-header`;

                        const baseInfoClass = tableType === `${tableType}__info`;

                        const centeredClass =
                            column.id === "centered" ? "table-centered-column" : "";

                        const sortProps = column.getSortByToggleProps?.() ?? {};
                        const { onClick, ...restSortProps } = sortProps;

                        return column.id !== "info" ? (
                            <th
                                className={classNames(
                                    baseHeaderClass,
                                    centeredClass,
                                    column.className
                                )}
                                {...{
                                    ...column.getHeaderProps(column.getSortByToggleProps()),
                                    title: undefined,
                                }}
                                tabIndex={0}
                                onKeyDown={e => handleKeyDown(e,() => onClick(e))}
                                onClick={onClick}
                            >
                                <span>{column.render("Header")}</span>
                                {column.disableSortBy || disableSort ? null : (
                                    <span className="table-header-icon">
                                        <SortIcon className={getSortIconClass(column, sortBy)} />
                                    </span>
                                )}
                            </th>
                        ) : (
                            <th
                                className={`${baseInfoClass} ${column.className ?? ""}`}
                                {...{
                                    ...column.getHeaderProps(column.getSortByToggleProps()),
                                    title: undefined,
                                }}
                                tabIndex={0}
                            >
                                {column.render("Header")}
                            </th>
                        );
                    })}
                </tr>
            ))}
        </thead>
    );
};
